import styled, { css } from "styled-components";

import { shimmer } from "shared/components/molecules/LoadingSkeleton/atoms/styles";
import { SwitchThemeContainer } from "shared/providers/Layout/components/NewTopBar/components/atoms/SwitchTheme/styles";

export const OptionsContainer = styled.div`
  list-style: none;
  margin: 0;

  width: 230px;
  display: flex;
  flex-direction: column;

  h1 {
    color: ${({ theme }) => theme?.console?.pageTitleColor};
    font: 600 1.125rem/1.6875rem "Inter";

    margin-bottom: 12px;
  }

  a,
  button,
  li,
  .switch-theme {
    display: block;

    color: ${({ theme }) => theme.colors.globalTopbar.textColor};
    font-family: Inter;
    font-size: 0.875rem;
    font-weight: 500;
    line-height: 17.5px;

    svg * {
      fill: ${({ theme }) => theme.colors.globalTopbar.iconsColor};
      path {
        stroke: ${({ theme }) => theme.colors.globalTopbar.iconsColor};
      }
    }
  }

  a,
  button,
  .switch-theme {
    transition: 0.3s all;
    display: flex;
    align-items: center;
    gap: 0.75rem;

    padding: 0.5rem;

    font: 500 0.8125rem/1.2188rem "Inter" !important;

    :hover {
      color: ${({ theme }) => theme?.colors?.globalTopbar?.textHoverColor};
    }
  }

  ul {
    margin-bottom: 0;
  }

  a svg {
    width: 20px;
    height: 20px;

    &.user-icon {
      stroke-width: 2px;
    }
  }

  button {
    border: none;
    background: none;
    width: 100%;
    text-align: start;

    :hover {
      cursor: pointer;
    }
  }

  ${SwitchThemeContainer} {
    flex-direction: row-reverse;
    justify-content: flex-end;
  }
`;

interface IUserMenuContainerProps {
  optionsIsOpen: boolean;
  scrollIsOnTop: boolean;
}

export const UserMenuContainer = styled.div<IUserMenuContainerProps>`
  border-radius: 4px;
  transition: 0.3s all;

  :hover {
    cursor: pointer;
  }

  .popover {
    padding: 0.31rem 0.5rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .avatar {
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;

    ${({ theme }) =>
      theme.mode === "dark"
        ? css`
            background-color: #303030;
            color: white;
          `
        : css`
            background-color: white;
            color: #303030;
          `}

    font-weight: 500;
  }

  img {
    object-fit: cover;

    &[data-is-loading="true"] {
      background: linear-gradient(
        90deg,
        ${({ theme }) => (theme.mode === "dark" ? "#2F2F2F" : "#BEBEBE")} 25%,
        ${({ theme }) => (theme.mode === "dark" ? "#424242" : "#CECECE")} 50%,
        ${({ theme }) => (theme.mode === "dark" ? "#2F2F2F" : "#BEBEBE")} 75%
      );
      background-size: 200% 100%;

      animation: ${shimmer} 1.5s infinite ease-in-out;
    }
  }

  .avatar,
  img {
    border-radius: 50%;
  }

  svg:not(.user-icon) {
    transition: 0.3s all;

    path {
      stroke: ${({ theme }) => theme?.colors?.globalTopbar?.iconsColor};
    }
  }

  ${({ optionsIsOpen }) =>
    optionsIsOpen &&
    css`
      svg:not(.user-icon) {
        transform: rotate(180deg);
      }
    `}
`;
